import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  primaryColor: {
    color: '#7833FF',
  },
  image: {
    width: 450,
    maxWidth: '100%',
    maxHeight: '100%',
    marginBottom: theme.spacing(4),
  },
  divider: {
    margin: theme.spacing(3, 0),
  },
  ratingStars: {
    marginBottom: theme.spacing(2),
  },
}));
